module.exports = __webpack_public_path__ + "img/newsLogo4.7c26025c.png";